import React from "react";
import "./footer.scss";

const Footer = () => {
  return (
    <div className="footer-container">
      <h1>
        developed by{" "}
        <a href="mailto: madkour17@hotmail.com">Madkour17@hotmail.com</a>
      </h1>
    </div>
  );
};

export default Footer;
